import ModalBackdrop from '../../components/ModalBackdrop'
import RulesSectionBody from './RulesSectionBody'
import SeeAllRulesRow from './SeeAllRulesRow'
import { rulesSection, type RulesSectionId } from './content'
import './rules.css'

/**
 * One rules section, met in context.
 *
 * Sits in the app's shared modal shell, the same one `ChipInfoModal` and `SkillMeterInfoModal`
 * use — this is the same kind of thing they are, and inventing a second panel treatment for it
 * would put two "explainer" chromes in one app.
 *
 * Holds no copy: every string comes from `RULES_SECTIONS`, and each section is written to read
 * standalone, because someone arriving here from the Banker toggle has not read the scoring
 * section and never will.
 */
export default function RulesSheet({
  sectionId,
  onClose,
  onSeeAllRules,
}: {
  sectionId: RulesSectionId
  onClose: () => void
  /** Opens the full screen at this same section. */
  onSeeAllRules: () => void
}) {
  const section = rulesSection(sectionId)

  return (
    <ModalBackdrop onClose={onClose}>
      {(close) => (
        <div className="rules-sheet">
          <RulesSectionBody section={section} />
          {/* Handed to the backdrop's own close so the panel animates out before the screen
              underneath swaps — a parallel timer here would race it. */}
          <SeeAllRulesRow onClick={() => close(onSeeAllRules)} />

          {/* Same foot as the chip and skill-meter sheets: the rules row navigates, Close
              dismisses. This one goes through the backdrop's own close so it plays the exit. */}
          <button className="rules-sheet__close" onClick={() => close()}>
            Close
          </button>
        </div>
      )}
    </ModalBackdrop>
  )
}
